import React from 'react'
import classNames from 'classnames'
import BackgroundImage from 'gatsby-background-image'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import styles from './title-content-background.module.scss'
import shared from '../shared.module.scss'

const TitleContentBackgroundSlice = ({ slice }) => {
  const {
    title_content_background_title,
    title_content_background_content,
    title_content_background_background_image,
    title_content_background_background_size,
    title_content_background_background_position_x,
    title_content_background_background_position_y,
    title_content_background_container_fluid,
    title_content_background_margin_bottom,
    title_content_background_text_color,
    title_content_background_background_color,
  } = slice.primary

  return (
    <BackgroundImage
      tag="section"
      fluid={ title_content_background_background_image.fluid }
      className={ classNames( styles.section, shared.padding, {
        [ shared.margin ]: title_content_background_margin_bottom,
        [ shared.backgroundSizeCover ]: title_content_background_background_size === 'cover',
        [ shared.backgroundSizeContain ]: title_content_background_background_size === 'contain',
        [ shared.backgroundPositionXLeft ]: title_content_background_background_position_x === 'left',
        [ shared.backgroundPositionXCenter ]: title_content_background_background_position_x === 'center',
        [ shared.backgroundPositionXRight ]: title_content_background_background_position_x === 'right',
        [ shared.backgroundPositionYTop ]: title_content_background_background_position_y === 'top',
        [ shared.backgroundPositionYCenter ]: title_content_background_background_position_y === 'center',
        [ shared.backgroundPositionYBottom ]: title_content_background_background_position_y === 'bottom',
      })}
      backgroundColor={ title_content_background_background_color }
      style={{ color: title_content_background_text_color }}
    >
      <Container fluid={ title_content_background_container_fluid }>
        <Row>
          <Col span={ 12 } lg={{ span: 5, pull: 5 }} >
            <h2 className={ styles.title }>{ title_content_background_title }</h2>

            <div
              className={ styles.content }
              dangerouslySetInnerHTML={{ __html: title_content_background_content.html }}
            />
          </Col>
        </Row>
      </Container>
    </BackgroundImage>
  )
}

export default TitleContentBackgroundSlice